const EVENT_CODES = {
  PERFORMANCE_EVENT_PAGE_LOAD: 'c_per_page_load_event', // 页面加载性能
  PERFORMANCE_EVENT_RESOURCE_LOAD: 'c_per_resource_load_event', // 页面资源加载
  SERVER_EVENT_XHR_LOAD: 'c_xhr_request_event', // xhr加载信息
  SERVER_EVENT_XHR_ERROR: 'c_xhr_request_error_event', // xhr错误信息
  ERROR_REPORT_EVENT: 'c_error_report_event', // js错误信息
  BEHAVIOUR_REPORT_EVENT: 'c_behaviour_report_event', // 用户行为信息
  SUPPLIER_WORKBENCH_REPORT_EVENT: 'c_supplier_workbench_report_event', // 供应商工作台埋点上报
  USER_LOGIN_DURATION_EVENT: 'c_event_user_login_duration_event', // 登录持续时间
};

export const REPORT_HOST = 'ubap-report.sany.com.cn';

export { EVENT_CODES };
